import { Box, Button } from "@mui/material";

const TONE = {
  solid: {
    bgcolor: "#2563eb",
    color: "#fff",
    borderColor: "#2563eb",
    "&:hover": { bgcolor: "#1d4ed8", borderColor: "#1d4ed8" },
  },
  soft: {
    bgcolor: "#e8f1ff",
    color: "#1d4ed8",
    borderColor: "#e8f1ff",
    "&:hover": { bgcolor: "#dbeafe", borderColor: "#dbeafe" },
  },
  ghost: {
    bgcolor: "#fff",
    color: "#1f2937",
    borderColor: "#e5e7eb",
    "&:hover": { bgcolor: "#f8fafc", borderColor: "#d1d5db" },
  },
  muted: {
    bgcolor: "#f3f4f6",
    color: "#9ca3af",
    borderColor: "#f3f4f6",
  },
};

export default function ChoicePills({ options, value, onChange, tone = "solid", disabled = false }) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {options.map((option) => {
        const selected = option.value === value;
        const optionDisabled = disabled || option.disabled;
        const look = selected ? tone : optionDisabled ? "muted" : "ghost";

        return (
          <Button
            key={option.value}
            disabled={optionDisabled}
            onClick={() => onChange(option.value)}
            sx={{
              minWidth: 0,
              px: 2,
              py: 0.75,
              borderRadius: 999,
              border: "1px solid",
              textTransform: "none",
              fontWeight: 600,
              lineHeight: 1.4,
              boxShadow: "none",
              ...TONE[look],
              "&.Mui-disabled": { ...TONE[look], opacity: 1 },
            }}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
}
